angular.module('charts')
  .directive("studentsListColumn", function () {
      return {
          restrict: "E",
          scope: {
              list: '=',
              type: '@',
              label: '@',
              description: '@',
              progressValue: '=',
              tooltipPlacement: '@'
          },
          templateUrl: '/resources/charts/partials/students-list-column.html',
          controller: ['$scope', 'assignMode', 'navigation', function ($scope, $assignMode, navigation) {

              $scope.isAssignMode = $assignMode.isAssignMode;

              $scope.selectStudent = function (item) {
                  navigation.goToItem(item, {pane: 'standards'}, {
                     keepStandards: true
                  });
              };

              $scope.getCircleClass = function() {
                  switch ($scope.type) {
                      case 'not-started':
                          return "circle-not-started";
                      case 'need-attention':
                          return 'triangle-need-attention';
                      case 'in-progress':
                          return "circle-in-progress";
                      case 'completed':
                          return "circle-proficient";
                  }
              };

              $scope.getAssignmentIcon = function(assignment) {
                  if (assignment.assignment_type.indexOf('GOAL') === 0) {
                      return "/resources/images/activity-feed-assigned-lesson-ongoing.png";
                  }

                  return "/resources/images/activity-feed-assigned-lesson.png";
              };
          }]
      };
  });
